import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {AlertService} from "../../shared/services/alert.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CollegeService} from "../../shared/services/college.service";

@Component({
  selector: 'ps-colleges',
  templateUrl: './colleges.component.html',
  styleUrls: ['./colleges.component.scss']
})
export class CollegesComponent implements OnInit {
  collegeCount: any = 0;

  constructor(private fb: FormBuilder,
              private router: Router,
              private alertService: AlertService,
              private collegeService: CollegeService,
              public modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.getCollegeCount();
  }

  getCollegeCount() {
    this.collegeService.totalCount().subscribe(data =>{
      this.collegeCount = data;
    })
  }


  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
